document.addEventListener('change', function (event) {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const form = select.closest('form');
  const option = select.options[select.selectedIndex];
  const price = form && form.closest('[data-product-section]')?.querySelector('[data-product-price]');
  const button = form?.querySelector('[data-add-button]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (button) {
    const available = option.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? 'Add to cart' : 'Sold out';
  }
});
